import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyDJK5ydQTPhbEcQJMR-b5Ww3g9cpcdPFXM",
  authDomain: "mozgolom-e0440.firebaseapp.com",
  databaseURL: "https://mozgolom-e0440.firebaseio.com",
  projectId: "mozgolom-e0440",
  storageBucket: "mozgolom-e0440.appspot.com",
  messagingSenderId: "505725731722",
  appId: "1:505725731722:web:882d3b8a568f80380f7e73",
  measurementId: "G-9R9CHM5320"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();  
